import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';

const SR_FLEX_DIRECTION_TO_CLASSNAME_MAPPING = {
  row: 'flex-row',
  rowReverse: 'flex-row-reverse',
  col: 'flex-col',
  colReverse: 'flex-col-reverse',
};

const SR_FLEX_JUSTIFY_TO_CLASSNAME_MAPPING = {
  start: 'flex-start',
  between: 'flex-between',
  around: 'flex-around',
  center: 'flex-justify-center',
};

const SR_FLEX_ALIGN_TO_CLASSNAME_MAPPING = {
  stretch: 'flex-align-stretch',
  start: 'flex-align-start',
  end: 'flex-align-end',
  center: 'flex-align-center',
  baseline: 'flex-align-baseline',
};

const SR_FLEX_WRAP_TO_CLASSNAME_MAPPING = {
  wrap: 'flex-wrap',
  nowrap: 'flex-nowrap',
};

function SrFlex({
  children,
  direction,
  justify,
  align,
  wrap,
  className,
  ..._styles
}) {
  return (
    <SrBox
      className={classnames(
        'SrFlex',
        SR_FLEX_DIRECTION_TO_CLASSNAME_MAPPING[direction],
        SR_FLEX_JUSTIFY_TO_CLASSNAME_MAPPING[justify],
        SR_FLEX_ALIGN_TO_CLASSNAME_MAPPING[align],
        SR_FLEX_WRAP_TO_CLASSNAME_MAPPING[wrap],
        className,
      )}
      {..._styles}
    >
      {children}
    </SrBox>
  );
}

SrFlex.propTypes = {
  ...SrBox.propTypes,
  direction: PropTypes.oneOf(Object.keys(SR_FLEX_DIRECTION_TO_CLASSNAME_MAPPING)),
  justify: PropTypes.oneOf(Object.keys(SR_FLEX_JUSTIFY_TO_CLASSNAME_MAPPING)),
  align: PropTypes.oneOf(Object.keys(SR_FLEX_ALIGN_TO_CLASSNAME_MAPPING)),
  wrap: PropTypes.oneOf(Object.keys(SR_FLEX_WRAP_TO_CLASSNAME_MAPPING)),
};

SrFlex.defaultProps = {
  direction: 'row',
};

SrFlex.displayName = 'SrFlex';

export default SrFlex;
